/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface PlaceFileDownloadPayload {
    careerId: string;
    classId: string;
}

export interface PlaceFileDownloadResponse {
    fileData: string;
    contentType: string;
}

class PlaceFileDownloadService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "placeFileDownload");
    }

    public async placeFileDownload(
        payload: PlaceFileDownloadPayload,
        resolved: (json: PlaceFileDownloadResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as PlaceFileDownloadResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default PlaceFileDownloadService;
